export default __webpack_public_path__ + "static/media/sch2_w640.774ff22e.jpg";